/**
 * **ResNweb**
 *
 * @exports bs_325
 * @category engines
 */
function factory({ window, document, thn, }) {
    const engine = {};
    /**
       * @memberOf module:bs_325
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve) {
            let aux;
            if (window.location.hostname === 'www.hotelazur.hu') {
                aux = (window.location.pathname.match(ctx.urlRe));
                if (aux && aux.length > 1 && ctx.langs.test(aux[1])) {
                    resolve(aux[1]);
                    return;
                }
            }
            aux = ctx.getHtmlLang({ attributes: ['lang'] });
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            aux = window.lang || document.querySelector('body').getAttribute('data-language');
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
            }
        });
    };
    /**
       * @memberOf module:bs_325
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        // The engine is not SPA, but there is a loader on first page load
        // Adding this observer to cover the unlikely event when our script
        // would load before the page does.
        const loaderEl = document.querySelector('#pageveil');
        if (loaderEl && !thn.resnwebLoadingObserver) {
            thn.resnwebLoadingObserver = thn.debounce(function thnResnwebLoadingObserver() {
                if (thn.isVisible(loaderEl)) {
                    if (ctx.widget.refresh() && ctx.widget.isSet()) {
                        ctx.widget.hide();
                    }
                }
            }, 150);
            thn.observeDom(loaderEl, thn.resnwebLoadingObserver, {
                childList: false,
                subtree: false,
                characterData: false,
                attributes: true,
            });
            thn.pageUnload(function () {
                thn.stopObserveDom(loaderEl, thn.resnwebLoadingObserver);
                delete thn.resnwebLoadingObserver;
            });
        }
    };
    /**
       * @memberOf module:bs_325
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        // DATES
        const dateBegin = window.arrive_date;
        const dateEnd = window.departure_date;
        let nights;
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin.replace(/-/g, '/');
            widgetData.dateEnd = dateEnd.replace(/-/g, '/');
            nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        // OCCUPANCY
        const adultsEl = document.querySelector('.dp-roomselected-edit-people .cell-adults input');
        const childrenEl = document.querySelector('.dp-roomselected-edit-people .cell-children input');
        const childrenAgesEls = (document.querySelector('.dp-roomselected-edit-people .cell-ops .children-ages') && [...document.querySelector('.dp-roomselected-edit-people .cell-ops .children-ages').children]) || [];
        widgetData.adults = thn.parseNumber(adultsEl?.value || 2);
        widgetData.children = thn.parseNumber(childrenEl?.value || 0);
        widgetData.guests = widgetData.adults + widgetData.children;
        // rooms dispo
        if (childrenAgesEls.length) {
            const childrenAges = childrenAgesEls.map(function getChildAge(childrenAgeEl) {
                return childrenAgeEl.firstElementChild && thn.parseNumber(childrenAgeEl.firstElementChild.value);
            });
            const room1Info = {
                adults: widgetData.adults,
                children: widgetData.children,
                childrenAges,
            };
            widgetData.roomsDispo = [room1Info];
        }
        // PRICE
        widgetData.currency = window.ca_currency;
        const noRoomsEl = document.querySelector('.no_rooms_available');
        const prices = [...document.querySelectorAll('.room-packages__item-current-price')]?.map((price) => thn.parseNumber(price.textContent)).filter(Boolean);
        if (prices.length && nights) {
            widgetData.price = Math.min(...prices) / nights;
        }
        else if (noRoomsEl) {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_325
       * @this thn.widgets.booking
       * @see {@link Booking#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingObserveDom = function bookingObserveDom(ctx) {
        // The engine is not SPA, but there is a loader on first page load
        // Adding this observer to cover the unlikely event when our script
        // would load before the page does.
        const loaderEl = document.querySelector('#pageveil');
        if (loaderEl && !thn.resnwebLoadingObserver) {
            thn.resnwebLoadingObserver = thn.debounce(function thnResnwebLoadingObserver() {
                if (ctx.widget.setData().isSet()) {
                    ctx.widget.save();
                    thn.stopObserveDom(loaderEl, thn.resnwebLoadingObserver);
                }
            }, 150);
            thn.observeDom(loaderEl, thn.resnwebLoadingObserver, {
                childList: false,
                subtree: false,
                characterData: false,
                attributes: true,
            });
            thn.pageUnload(function () {
                thn.stopObserveDom(loaderEl, thn.resnwebLoadingObserver);
                delete thn.resnwebLoadingObserver;
            });
        }
    };
    /**
       * @memberOf module:bs_325
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        // DATES
        const stayDatesEls = document.querySelector('.hotel-nights') && [...document.querySelector('.hotel-nights').children];
        const dateBeginEl = stayDatesEls && stayDatesEls.length && stayDatesEls[0] && stayDatesEls[0].firstElementChild;
        const dateEndEl = stayDatesEls && stayDatesEls.length && stayDatesEls.length > 1 && stayDatesEls[1] && stayDatesEls[1].firstElementChild;
        widgetData.dateBegin = dateBeginEl && dateBeginEl.textContent && dateBeginEl.textContent.replace(/-/g, '/');
        widgetData.dateEnd = dateEndEl && dateEndEl.textContent && dateEndEl.textContent.replace(/-/g, '/');
        // PRICE
        const priceEl = document.querySelector('.total');
        const hasPrice = !!(priceEl && priceEl.textContent);
        widgetData.price = hasPrice && thn.parseNumber(priceEl.textContent);
        widgetData.currency = (hasPrice && thn.parseCurrency(priceEl.textContent)) || window.ca_currency;
        widgetData.rooms = document.querySelectorAll('.hotel-room').length || 1;
        // BOOKING_ID
        // Unfortunately in order to get the booking id, we have to extract it from text in a <p> tag...
        const confirmationEl = document.querySelector('#thankyou');
        const bookingIdEl = confirmationEl && confirmationEl.children && [...confirmationEl.children].length && [...confirmationEl.children].length > 2 && [...confirmationEl.children][3];
        const bookingIdMatches = bookingIdEl && bookingIdEl.textContent && bookingIdEl.textContent.match(/: {1,2}([A-Z0-9]+)/);
        widgetData.bookingId = bookingIdMatches && bookingIdMatches.length && bookingIdMatches.length > 1 && bookingIdMatches[1];
        return widgetData;
    };
    return engine;
}

export { factory };
